import { Check, Save, X } from 'lucide-react';
import { Button } from '@/components/Button';
export const STEPS = [
  { key: 'campaign', label: 'Campaign', description: 'Goal & budget' },
  { key: 'groups', label: 'Ad groups & ads', description: 'Audience & creative' },
  { key: 'review', label: 'Review', description: 'Check & publish' },
] as const;
export type StepKey = (typeof STEPS)[number]['key'];

export function StepRail({ step, onStep, issuesFor, doneFor, adGroupCount, adCount, onSaveDraft, onClose, onDiscard }: {
  step: StepKey; onStep: (s: StepKey) => void; issuesFor: (s: StepKey) => string[]; doneFor: (s: StepKey) => boolean;
  adGroupCount: number; adCount: number; onSaveDraft: () => void; onClose: () => void; onDiscard: () => void;
}) {
  const index = STEPS.findIndex((s) => s.key === step);
  return <div className="tt-step-rail">
    <nav className="tt-step-list" aria-label="Campaign steps">{STEPS.map((s, i) => {
      const issues = issuesFor(s.key);
      const done = doneFor(s.key) || (i < index && issues.length === 0);
      return <button key={s.key} type="button" className="tt-step" aria-current={s.key === step ? 'step' : undefined} onClick={() => onStep(s.key)} title={i < index && issues.length ? issues.join('\n') : s.description}>
        <span className="tt-step-number">{done ? <Check size={14} /> : i + 1}</span>
        <span><strong>{s.label}</strong><small>{s.key === 'groups' && adGroupCount ? `${adGroupCount} groups · ${adCount} ads` : s.description}</small></span>
        {i < index && issues.length > 0 && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-warning" aria-label="Incomplete" />}
      </button>;
    })}</nav>
    <div className="tt-step-controls">
      <Button size="sm" variant="secondary" iconLeft={<Save size={13} />} onClick={onSaveDraft}>Save draft</Button>
      <button type="button" onClick={onDiscard} className="text-xs text-text-muted hover:text-danger">Start over</button>
      <button type="button" onClick={onClose} title="Save and close workspace" aria-label="Save and close workspace" className="p-2 text-text-muted hover:text-text-primary"><X size={15} /></button>
    </div>
  </div>;
}
